import React, { ReactNode, useMemo, useState } from 'react';
import PreviewModeContext from './PreviewModeContext';

interface PreviewModeProviderProps {
  children: ReactNode;
}

function PreviewModeProvider({
  children
}: PreviewModeProviderProps): React.ReactElement {
  const [isPreviewMode, setIsPreviewMode] = useState<boolean>(true);

  const value = useMemo(
    () => ({
      isPreviewMode,
      setIsPreviewMode
    }),
    [isPreviewMode]
  );

  return (
    <PreviewModeContext.Provider value={value}>
      {children}
    </PreviewModeContext.Provider>
  );
}

export default PreviewModeProvider;
